import { SortOrder } from '@moonpig/web-explore-types-graphql'
import { getAllSelectedFilters } from './getAllSelectedFilters'
import {
  ApplicableFilter,
  FilterCategory,
  IntegerFilter,
} from '../../services/types/services'
import { isPersistedFilter } from '../../store/helpers/persistFilterSelection'
import { StateIntegerFilter } from '../../store/slices/filters/types'

export const shouldShowClearButton = ({
  category,
  selectedFilters,
  integerFilters,
  sortValue,
  defaultSortValue,
}: {
  category?: FilterCategory | IntegerFilter
  selectedFilters?: ApplicableFilter[]
  integerFilters?: StateIntegerFilter[]
  sortValue?: SortOrder
  defaultSortValue?: SortOrder
}) => {
  if (sortValue !== defaultSortValue) {
    return true
  }

  if (integerFilters?.some(filter => filter.value !== null)) {
    return true
  }

  if (!selectedFilters || selectedFilters.length === 0) {
    return false
  }

  const nonPersistedSelectedFilters = selectedFilters.filter(
    f => !isPersistedFilter(f),
  )

  return category && category.__typename === 'FilterCategory'
    ? getAllSelectedFilters(category.children).length > 0
    : nonPersistedSelectedFilters.length > 0
}
